import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=a94c34ba&scoped=true&"
import script from "./Center.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Center.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Center.vue?vue&type=style&index=0&id=a94c34ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94c34ba",
  null
  
)

export default component.exports